import { render, staticRenderFns } from "./paipanRecord.vue?vue&type=template&id=ff6d2db6&scoped=true"
import script from "./paipanRecord.vue?vue&type=script&lang=js"
export * from "./paipanRecord.vue?vue&type=script&lang=js"
import style0 from "./paipanRecord.vue?vue&type=style&index=0&id=ff6d2db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6d2db6",
  null
  
)

export default component.exports